import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA, Pipe, InjectionToken} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {Http, HttpModule} from '@angular/http';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {environment} from '../environments/environment';
import {IdentityProvider, AuthService, OauthConfiguration, getSessionToken, getIdentityToken,
        getAuthorizeToken, AuthorizationGuardService, SessionEventNotificationService,
        OauthAuthGuardRouteConfiguration} from '@westjetairlines/wjesd-oauth2-library';
import {ConfirmationDialog, MessageBarComponent, NotificationsService, SpinnerComponent, Autofocus} from '@westjetairlines/wjesd-component-library'
import {CreateModule} from './create/create.module';
import {EditModule} from './edit/edit.module';
import {SummaryModule} from './summary/summary.module';
import {SearchModule} from './search/search.module';
import {PageNotFoundComponent} from './page-not-found.component';
import {BaseStepComponent} from './steps/base-step/base-step.component';
import {LoginComponent} from './layout/login/login.component';
import {NavigationComponent} from './layout/navigation/navigation.component';
import {NavigationService} from './shared/services/navigation.service';
import {WelcomePageComponent} from './welcome-page/welcome-page.component';
import {ForbiddenPageComponent} from './forbidden-page/forbidden-page.component';
import {SessionNotificationMessageComponent} from './layout/session-notification-message/session-notification-message.component';
import {StepActionTypeComponent} from './steps/step-action-type/step-action-type.component';
import {CreateComponent} from './create/create.component';
import {EditComponent} from './edit/edit.component';
import {ReservationStepComponent} from './steps/reservation-step/reservation-step.component';
import {CreditStepComponent} from './steps/credit-step/credit-step.component';
import {GuestCreditStepComponent} from './steps/guest-credit-step/guest-credit-step.component';
import {AgencyStepComponent} from './steps/agency-step/agency-step.component';
import {StepIndicatorComponent} from './layout/step-indicator/step-indicator.component';
import {ValidationModule} from './shared/validation/validation.module';
import {IataStepComponent} from './steps/iata-step/iata-step.component';
import {HttpService} from './shared/services/http.service';
import {WORKFLOW_DATA_SERVICE_TOKEN, WorkflowDataService} from './shared/services/workflow-data.service';
import {TRAVEL_CREDIT_SERVICE_TOKEN, TravelCreditService} from './shared/services/travel-credit.service';
import {IATA_SERVICE_TOKEN, IataService} from './shared/services/iata.service';
import { ImportIataModule} from "./import-iata/import-iata.module";
import { ManageIataModule } from './manage-iata/manage-iata.module';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    CreateModule,
    EditModule,
    SummaryModule,
    SearchModule,
    ImportIataModule,
    ManageIataModule,
    ValidationModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    StepActionTypeComponent,
    StepIndicatorComponent,
    LoginComponent,
    PageNotFoundComponent,
    BaseStepComponent,
    NavigationComponent,
    WelcomePageComponent,
    ForbiddenPageComponent,
    MessageBarComponent,
    SessionNotificationMessageComponent,
    ConfirmationDialog,
    SpinnerComponent,
    CreateComponent,
    EditComponent,
    ReservationStepComponent,
    CreditStepComponent,
    GuestCreditStepComponent,
    AgencyStepComponent,
    Autofocus,
    IataStepComponent
  ],
  providers: [
    HttpService,
    { provide: OauthAuthGuardRouteConfiguration, useValue: environment.oauthRoute},
    { provide: OauthConfiguration, useValue: environment.oauthProperties },
    { provide: getSessionToken, useClass: AuthService },
    { provide: getAuthorizeToken, useClass: AuthService },
    { provide: getIdentityToken, useClass: IdentityProvider },
    { provide: WORKFLOW_DATA_SERVICE_TOKEN, useClass: WorkflowDataService },
    { provide: TRAVEL_CREDIT_SERVICE_TOKEN, useClass: TravelCreditService },
    { provide: IATA_SERVICE_TOKEN, useClass: IataService },
    SessionEventNotificationService,
    AuthorizationGuardService,
    NavigationService,
    NotificationsService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
  exports: [StepActionTypeComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts